// Aligns two onboarding page sequences for side-by-side comparison.
//
// Pages are keyed by field + per-field occurrence index (so duplicates like
// repeated setting_up align by occurrence). An LCS over those keys yields rows
// that keep matching pages on the same line and surface inserts/deletes as
// one-sided rows.

function keysOf(items) {
  const seen = {};
  return items.map((it) => {
    const f = it.page.field;
    const n = (seen[f] = (seen[f] || 0) + 1) - 1;
    return f + '#' + n;
  });
}

function lcsTable(a, b) {
  const m = a.length;
  const n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--) {
    for (let j = n - 1; j >= 0; j--) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  return dp;
}

function isChanged(a, b) {
  if (a.enabled !== b.enabled) return true;
  return JSON.stringify(a.page) !== JSON.stringify(b.page);
}

// Returns rows: { status: 'same'|'changed'|'a-only'|'b-only', a, b, ai, bj }
export function diffItems(aItems, bItems) {
  const ka = keysOf(aItems);
  const kb = keysOf(bItems);
  const dp = lcsTable(ka, kb);
  const rows = [];
  let i = 0;
  let j = 0;
  while (i < aItems.length && j < bItems.length) {
    if (ka[i] === kb[j]) {
      const changed = isChanged(aItems[i], bItems[j]);
      rows.push({ status: changed ? 'changed' : 'same', a: aItems[i], b: bItems[j], ai: i, bj: j });
      i++;
      j++;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      rows.push({ status: 'a-only', a: aItems[i], b: null, ai: i, bj: null });
      i++;
    } else {
      rows.push({ status: 'b-only', a: null, b: bItems[j], ai: null, bj: j });
      j++;
    }
  }
  while (i < aItems.length) { rows.push({ status: 'a-only', a: aItems[i], b: null, ai: i, bj: null }); i++; }
  while (j < bItems.length) { rows.push({ status: 'b-only', a: null, b: bItems[j], ai: null, bj: j }); j++; }
  return rows;
}

export function diffSummary(rows) {
  const c = { same: 0, changed: 0, 'a-only': 0, 'b-only': 0 };
  rows.forEach((r) => { c[r.status] = (c[r.status] || 0) + 1; });
  return c;
}
